export default {
  es: {
    email: 'Correo electrónico',
    recoveryTitle: 'Recuperar contraseña',
    recoveryContent:
      'Recibirá un email con un enlace para que pueda hacer el reestablecimiento de su contraseña.',
    recoveryButton: 'Recuperar',
    notification:
      '¡Se ha enviado un link de recuperación de contraseña a su correo!',
    recoveryPatient:
      'Se ha enviado un link de recuperación de contraseña al correo del paciente!'
  },
  en: {
    email: 'Email',
    recoveryTitle: 'Recover password',
    recoveryContent:
      'You will receive an email with a link so you can reset your password.',
    recoveryButton: 'Recover',
    notification: 'A password recovery link has been sent to your email!',
    recoveryPatient: 'A password recovery link has been sent to patient email!'
  }
};
